import React from 'react';
import Icon from 'tbk-components/src/components/Icon';

import { useTranslation } from 'react-i18next';

const CustomBlogRollTile = (props: any) => {
	const { blogroll } = props;
	const { t } = useTranslation();

	// get date string
	const [date, month, year] = new Date(blogroll.post_date.substr(0,10).replace(/-/g, "/"))
		.toLocaleDateString('en-GB', {
			day: 'numeric',
			month: 'long',
			year: 'numeric',
		})
		.split(' ');
	return (
		<div
			className={`blogroll-results__item blogroll-results__item--${blogroll.post_type}`}
		>
			<div className="blogroll-results__item-content">
				{blogroll.post_type === 'school' ? (
					blogroll.resources[0]?.file ? (
						<>
							<a target="_blank" href={blogroll.resources[0]?.file} className="stretched-link" rel="noreferrer">
								<h5 className="blogroll-results__item-heading">
									{blogroll?.post_title}
								</h5>
							</a>
							<Icon name="download" />
						</>
					) : (
						<h5 className="blogroll-results__item-heading">
							{blogroll?.post_title}
						</h5>
					)
				) : (
					<>
						<a href={blogroll.permalink} className="stretched-link">
							<h3 className="blogroll-results__item-heading">
								{blogroll.post_title}
							</h3>
						</a>
						<p className="blogroll-results__item-date">
							{month} {date}, {year}
						</p>
					</>
				)}
			</div>
		</div>
	);
};

export default CustomBlogRollTile;
